import { lightTheme } from "../../../theme/theme";

type Theme = typeof lightTheme;

export const CardStyles = (theme: Theme) => {
  const accent = `var(--accent, ${theme.primary})`;

  return {
    card: {
      width: "100%",
      borderRadius: 16,
      border: `1px solid ${accent}22`,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column" as const,
      boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
      transition:
        "transform .25s ease, box-shadow .25s ease, border-color .25s ease",
      textDecoration: "none",
      color: theme.text,
    },
    cardHover: {
      transform: "translateY(-4px)",
      boxShadow: "0 14px 30px rgba(0,0,0,0.12)",
      borderColor: `${accent}55`,
    },
    previewWrap: {
      position: "relative" as const,
      overflow: "hidden",
      aspectRatio: "16 / 9",
      background: `${accent}0F`,
    },
    preview: {
      width: "100%",
      objectFit: "cover" as const,
      display: "block",
      transform: "scale(1)",
      transition: "transform .5s ease",
    },
    previewHover: {
      transform: "scale(1.06)",
    },
    previewMask: {
      content: '""',
      position: "absolute" as const,
      inset: 0,
      background:
        "linear-gradient(180deg, rgba(0,0,0,0.00) 55%, rgba(0,0,0,0.06) 100%)",
      pointerEvents: "none" as const,
    },
    body: {
      padding: 16,
      display: "flex",
      flexDirection: "column" as const,
      gap: 10,
      background: theme.card2,
      alignItems: "flex-start", // ← add this
    },
    cardTitle: {
      fontFamily: '"Poppins", serif',
      fontWeight: 600,
      fontSize: 18,
      lineHeight: 1.25,
      letterSpacing: 0.2,
      color: theme.text,
      margin: 0,
    },
    blurb: {
      fontSize: 13,
      opacity: 0.87,
      lineHeight: 1.5,
      color: theme.text,
      fontFamily: '"Poppins", serif',
    },
    moreBtn: {
      alignSelf: "flex-start",
      padding: 0,
      background: "transparent",
      border: "none",
      fontSize: 14,
      fontWeight: 600,
      color: theme.text,
      cursor: "pointer",
      fontFamily: '"Poppins", serif',
    },
  } as const;
};
